export const css = {
	root: '_12S23b1D',
	' _key': 'ascm-theme/ascm/variants/ctsc2024'
};

export default css;
